<template>
  <div class="venue-add-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/venueList' }">
          <i class="el-icon-office-building"></i>展馆展区管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ isEdit ? '编辑展馆' : '新增展馆' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 头部操作区域 -->
      <div class="card-header">
        <div class="header-title">
          <i class="el-icon-circle-plus-outline"></i>
          <span>{{ isEdit ? '编辑展馆' : '新增展馆' }}</span>
        </div>
        <div class="header-actions">
          <el-button size="mini" icon="el-icon-back" @click="goBack">返回列表</el-button>
        </div>
      </div>

      <!-- 表单内容 -->
      <div class="form-container">
        <el-form
          ref="venueForm"
          :model="form"
          :rules="rules"
          label-width="120px"
          size="mini"
          :disabled="loading"
        >
          <!-- 基本信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-info"></i>
              </div>
              <div class="section-title">基础展馆信息</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="展馆名称" prop="title">
                  <el-input
                    v-model="form.title"
                    placeholder="请输入展馆名称"
                    maxlength="50"
                    show-word-limit
                    prefix-icon="el-icon-edit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="展馆分类" prop="category_id">
                  <el-select
                    v-model="form.category_id"
                    placeholder="请选择展馆分类"
                    filterable
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="展馆状态" prop="status">
                  <el-radio-group v-model="form.status">
                    <el-radio :label="0">维护中</el-radio>
                    <el-radio :label="1">营业中</el-radio>
                    <el-radio :label="2">已关闭</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适配展会类型" prop="exhibition_type">
                  <el-select v-model="form.exhibition_type" placeholder="选择展会适配类型" style="width:100%">
                    <el-option label="消费零售展" value="1" />
                    <el-option label="B2B专业行业展" value="2" />
                    <el-option label="政企会议会展" value="3" />
                    <el-option label="户外大型特展" value="4" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="展馆等级" prop="level">
                  <el-select
                    v-model="form.level"
                    placeholder="请选择展馆等级"
                    style="width: 100%"
                  >
                    <el-option label="一级展馆" value="1"></el-option>
                    <el-option label="二级展馆" value="2"></el-option>
                    <el-option label="三级展馆" value="3"></el-option>
                    <el-option label="特级展馆" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适合展会规模" prop="scale_type">
                  <el-select v-model="form.scale_type" placeholder="展会适配规模" style="width:100%">
                    <el-option label="小型(≤500人)" value="1" />
                    <el-option label="中型(500-3000人)" value="2" />
                    <el-option label="大型(3000-10000人)" value="3" />
                    <el-option label="超大型(万人以上)" value="4" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="展馆描述" prop="description">
                  <el-input
                    v-model="form.description"
                    type="textarea"
                    :rows="3"
                    placeholder="展馆简介、定位、特色优势"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 位置信息 统一三级级联 和列表/展区页面保持一致 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-location-information"></i>
              </div>
              <div class="section-title">区位地址信息</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="所在省市区县" prop="areaCode">
                  <el-cascader
                    ref="cascaderAddr"
                    style="width:100%"
                    v-model="areaList"
                    clearable
                    filterable
                    :props="propsdata"
                    placeholder="选择省/市/区"
                    @change="handleAreaChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    v-model="form.address"
                    placeholder="街道、门牌号、园区楼层"
                    prefix-icon="el-icon-location"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="经度">
                  <el-input
                    v-model="form.longitude"
                    placeholder="地图经度坐标"
                    type="number"
                    step="0.000001"
                  >
                    <template slot="append">°</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度">
                  <el-input
                    v-model="form.latitude"
                    placeholder="地图纬度坐标"
                    type="number"
                    step="0.000001"
                  >
                    <template slot="append">°</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 规模信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="section-title">场地规模参数</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="展馆总面积" prop="area">
                  <el-input
                    v-model="form.area"
                    placeholder="展馆总面积"
                    type="number"
                    min="0"
                  >
                    <template slot="append">㎡</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最大容纳人数" prop="capacity">
                  <el-input-number
                    v-model="form.capacity"
                    :min="0"
                    :max="1000000"
                    placeholder="最大容纳人数"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="展厅总数" prop="hall_count">
                  <el-input-number
                    v-model="form.hall_count"
                    :min="0"
                    :max="100"
                    placeholder="独立展厅数量"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="层高">
                  <el-input
                    v-model="form.ceiling_height"
                    placeholder="展馆层高"
                    type="number"
                    min="0"
                    step="0.1"
                  >
                    <template slot="append">米</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="地面最大承重">
                  <el-input
                    v-model="form.max_load"
                    placeholder="地面承重"
                    type="number"
                    min="0"
                    step="0.1"
                  >
                    <template slot="append">吨/㎡</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="标准柱间距">
                  <el-input
                    v-model="form.column_spacing"
                    placeholder="柱子间距"
                    type="number"
                    min="0"
                    step="0.1"
                  >
                    <template slot="append">米</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 设施信息 配套字段与列表筛选联动 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-s-tools"></i>
              </div>
              <div class="section-title">配套设施配置</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="展馆配套设施">
                  <el-checkbox-group v-model="form.support_list" class="facilities-group">
                    <el-checkbox
                      v-for="item in supportMapList"
                      :key="item.value"
                      :label="item.value"
                      class="facility-checkbox"
                    >
                      <div class="facility-item">
                        <i :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="停车位总数">
                  <el-input-number
                    v-model="form.parking_spaces"
                    :min="0"
                    :max="10000"
                    placeholder="车位数量"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会议室数量">
                  <el-input-number
                    v-model="form.meeting_rooms"
                    :min="0"
                    :max="100"
                    placeholder="会议室数量"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 联系信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-phone"></i>
              </div>
              <div class="section-title">招商联系信息</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="招商电话" prop="phone">
                  <el-input
                    v-model="form.phone"
                    placeholder="招商联系电话"
                    prefix-icon="el-icon-phone"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="对接联系人" prop="contact_person">
                  <el-input
                    v-model="form.contact_person"
                    placeholder="展馆招商负责人"
                    prefix-icon="el-icon-user"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="商务邮箱" prop="email">
                  <el-input
                    v-model="form.email"
                    placeholder="商务合作邮箱"
                    prefix-icon="el-icon-message"
                    type="email"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="官方网址">
                  <el-input
                    v-model="form.website"
                    placeholder="展馆官网地址"
                    prefix-icon="el-icon-link"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 图片信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-picture"></i>
              </div>
              <div class="section-title">展馆图片素材</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="首页封面图" prop="cover_image">
                  <el-upload
                    class="cover-upload"
                    action="/api/upload"
                    :headers="uploadHeaders"
                    :on-success="handleCoverImageSuccess"
                    :on-remove="handleCoverImageRemove"
                    :before-upload="beforeImageUpload"
                    :file-list="coverImageList"
                    list-type="picture-card"
                    :limit="1"
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">建议800*400px，JPG/PNG，≤2MB</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="展馆实景图集" prop="gallery_images">
                  <el-upload
                    class="gallery-upload"
                    action="/api/upload"
                    :headers="uploadHeaders"
                    :on-success="handleGalleryImageSuccess"
                    :on-remove="handleGalleryImageRemove"
                    :before-upload="beforeImageUpload"
                    :file-list="galleryImageList"
                    list-type="picture-card"
                    :limit="10"
                    multiple
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">最多10张实景图，单张≤2MB</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="展厅平面图纸" prop="layout_images">
                  <el-upload
                    class="layout-upload"
                    action="/api/upload"
                    :headers="uploadHeaders"
                    :on-success="handleLayoutImageSuccess"
                    :on-remove="handleLayoutImageRemove"
                    :before-upload="beforeImageUpload"
                    :file-list="layoutImageList"
                    list-type="picture-card"
                    :limit="5"
                    multiple
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">平面布局图，单张≤5MB</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 详细信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="section-title">招商详情说明</div>
            </div>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="交通指南">
                  <el-input
                    v-model="form.transportation"
                    type="textarea"
                    :rows="3"
                    placeholder="地铁、公交、自驾路线指引"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="周边配套">
                  <el-input
                    v-model="form.surrounding_facilities"
                    type="textarea"
                    :rows="3"
                    placeholder="酒店、餐饮、物流、商圈配套"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="租赁注意事项">
                  <el-input
                    v-model="form.notes"
                    type="textarea"
                    :rows="3"
                    placeholder="层高限制、消防要求、搭建规范、价格说明"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 操作按钮 -->
          <div class="form-actions">
            <el-button size="mini" @click="goBack">
              <i class="el-icon-back"></i>取消返回
            </el-button>
            <el-button size="mini" type="primary" :loading="loading" @click="submitForm">
              <i class="el-icon-check"></i>{{ isEdit ? '更新展馆信息' : '保存展馆' }}
            </el-button>
            <el-button size="mini" @click="resetForm">
              <i class="el-icon-refresh"></i>重置表单
            </el-button>
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "VenueForm",
  data() {
    return {
      loading: false,
      isEdit: false,
      venueId: null,
      // 省市区级联 与列表/展区页面完全共用配置
      areaList: [],
      propsdata: {
        checkStrictly: true,
        lazy: true,
        lazyLoad(node, resolve) {
          const url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            parent_id: node.value
          }
          if (node.level === 0) param.parent_id = 1
          this.$axios.post(url, param).then(res => {
            if (res.data.code === 200) {
              const nodes = res.data.data.map(item => ({
                value: item.id,
                label: item.name,
                leaf: node.level >= 2
              }))
              resolve(nodes)
            }
          }).catch(() => resolve([]))
        }
      },
      // 配套设施映射 与列表筛选字段统一
      supportMapList: [
        { label: "标准展位", value: "booth", icon: "el-icon-s-grid" },
        { label: "会议室", value: "meeting", icon: "el-icon-office-building" },
        { label: "停车场", value: "park", icon: "el-icon-position" },
        { label: "仓储物流", value: "storage", icon: "el-icon-truck" },
        { label: "餐饮配套", value: "food", icon: "el-icon-food" },
        { label: "LED大屏", value: "screen", icon: "el-icon-video-camera" },
        { label: "水电全通", value: "water_electric", icon: "el-icon-lightning" },
        { label: "WiFi全覆盖", value: "wifi", icon: "el-icon-wifi" }
      ],
      // 完整表单字段（包含展会行业拓展字段，对接列表筛选参数）
      form: {
        title: '',
        category_id: '',
        status: 1,
        level: '',
        exhibition_type: '',
        scale_type: '',
        description: '',
        province_id: '',
        city_id: '',
        district_id: '',
        address: '',
        longitude: '',
        latitude: '',
        area: '',
        capacity: 0,
        hall_count: 0,
        ceiling_height: '',
        max_load: '',
        column_spacing: '',
        support_list: [],
        parking_spaces: 0,
        meeting_rooms: 0,
        phone: '',
        contact_person: '',
        email: '',
        website: '',
        cover_image: '',
        gallery_images: [],
        layout_images: [],
        transportation: '',
        surrounding_facilities: '',
        notes: ''
      },
      rules: {
        title: [{ required: true, message: '请输入展馆名称', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择展馆分类', trigger: 'change' }],
        address: [{ required: true, message: '请填写详细地址', trigger: 'blur' }],
        area: [{ required: true, message: '请填写展馆总面积', trigger: 'blur' }],
        phone: [{ required: true, message: '请填写招商联系电话', trigger: 'blur' }]
      },
      categoryList: [],
      // 上传配置
      uploadHeaders: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      },
      coverImageList: [],
      galleryImageList: [],
      layoutImageList: []
    };
  },
  created() {
    this.venueId = this.$route.query.id;
    this.isEdit = !!this.venueId;
    this.getCategoryList();
    if (this.isEdit) this.getVenueDetail();
  },
  methods: {
    // 获取展馆分类
    getCategoryList() {
    //   const params = {
    //     access_token: sessionStorage.getItem('token'),
    //     company_id: sessionStorage.getItem('company_id')
    //   }
    //   this.$axios.get('/api/venue/categoryList', { params }).then(res => {
    //     if (res.code === 200) this.categoryList = res.data || []
    //   })
    },
    // 三级地区选择赋值
    handleAreaChange(val) {
      if (val && val.length) {
        this.form.province_id = val[0];
        this.form.city_id = val[1] || '';
        this.form.district_id = val[2] || '';
      } else {
        this.form.province_id = '';
        this.form.city_id = '';
        this.form.district_id = '';
      }
    },
    // 编辑回显详情
    getVenueDetail() {
      this.loading = true;
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        id: this.venueId
      }
      this.$axios.venueDetail(param).then(res => {
        this.loading = false;
        if (res.code !== 200) return this.$message.error(res.msg), this.goBack();
        const data = res.data;
        // 回填基础字段
        Object.keys(this.form).forEach(k => {
          if (data[k] !== undefined && data[k] !== null) this.form[k] = data[k];
        })
        // 配套设施字符串转数组
        if (typeof this.form.support_list === 'string') this.form.support_list = this.form.support_list.split(',');
        // 图片回显
        if (this.form.cover_image) this.coverImageList = [{ url: this.form.cover_image, name: "封面" }];
        if (this.form.gallery_images?.length) this.galleryImageList = this.form.gallery_images.map(url => ({ url }));
        if (this.form.layout_images?.length) this.layoutImageList = this.form.layout_images.map(url => ({ url }));
        // 省市区级联回显
        if (this.form.province_id) {
          this.areaList = [this.form.province_id, this.form.city_id, this.form.district_id].filter(Boolean);
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("获取展馆详情失败");
      })
    },
    // 上传校验
    beforeImageUpload(file) {
      const isImg = ["image/jpeg", "image/png"].includes(file.type);
      const sizeOk = file.size / 1024 / 1024 < 5;
      if (!isImg) this.$message.error("仅支持JPG/PNG图片");
      if (!sizeOk) this.$message.error("图片不能超过5MB");
      return isImg && sizeOk;
    },
    // 封面上传
    handleCoverImageSuccess(res) {
      if (res.code === 200) this.form.cover_image = res.data.url;
    },
    handleCoverImageRemove() {
      this.form.cover_image = '';
      this.coverImageList = [];
    },
    // 图集上传
    handleGalleryImageSuccess(res) {
      if (res.code === 200) this.form.gallery_images.push(res.data.url);
    },
    handleGalleryImageRemove(file) {
      const url = file.url || file.response.data.url;
      this.form.gallery_images = this.form.gallery_images.filter(u => u !== url);
      this.galleryImageList = this.galleryImageList.filter(item => item.url !== url);
    },
    // 平面图上传
    handleLayoutImageSuccess(res) {
      if (res.code === 200) this.form.layout_images.push(res.data.url);
    },
    handleLayoutImageRemove(file) {
      const url = file.url || file.response.data.url;
      this.form.layout_images = this.form.layout_images.filter(u => u !== url);
      this.layoutImageList = this.layoutImageList.filter(item => item.url !== url);
    },
    // 提交保存
    submitForm() {
      this.$refs.venueForm.validate(valid => {
        if (!valid) return this.$message.warning("请完善必填项");
        this.loading = true;
        const submitData = {
          ...this.form,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          operator_id: sessionStorage.getItem('user_id')
        };
        if (this.isEdit) submitData.id = this.venueId;
        this.$axios.venueSave(submitData).then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.$message.success(this.isEdit ? "展馆更新成功" : "展馆新增成功");
            this.$router.push("/venueList");
          } else {
            this.$message.error(res.msg || "保存失败");
          }
        }).catch(() => {
          this.loading = false;
          this.$message.error("网络异常，保存失败");
        })
      })
    },
    // 重置
    resetForm() {
      if (this.isEdit) return this.getVenueDetail();
      this.$refs.venueForm.resetFields();
      this.areaList = [];
      this.form.support_list = [];
      this.form.gallery_images = [];
      this.form.layout_images = [];
      this.coverImageList = [];
      this.galleryImageList = [];
      this.layoutImageList = [];
      this.form.province_id = '';
      this.form.city_id = '';
      this.form.district_id = '';
    },
    // 返回列表
    goBack() {
      this.$router.push("/venueList");
    }
  }
};
</script>

<style scoped>
/* 支付宝主题全局穿透，与列表、展区表单统一 */
:deep(.el-card) {
  border-radius: 8px;
  border: 1px solid #e5e6eb;
}
:deep(.el-card__header) {
  padding: 16px 20px !important;
}
:deep(.el-button--primary) {
  background-color: #1677ff;
  border-color: #1677ff;
}
:deep(.el-input__inner),
:deep(.el-select__input),
:deep(.el-input-number__inner) {
  border-radius: 4px;
}
:deep(.el-form-item__label) {
  color: #1d2129;
  font-weight: 500;
}
:deep(.el-upload--picture-card) {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  background: #fafafa;
}
:deep(.el-upload--picture-card:hover) {
  border-color: #1677ff;
  background: #f0f7ff;
}

.venue-add-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.breadcrumb-container {
  margin-bottom: 16px;
}

.main-card {
  background: #fff;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 16px;
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}
.header-title i {
  color: #1677ff;
  margin-right: 8px;
  font-size: 18px;
}

.form-container {
  padding: 0 20px 20px;
}

.form-section {
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  margin-bottom: 20px;
  position: relative;
}
.form-section::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #1677ff;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
}
.section-icon {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 16px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}

/* 配套设施多选框布局 */
.facilities-group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 8px;
}
.facility-checkbox {
  margin-right: 0;
}
.facility-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  background: #fafafa;
  width: 100%;
}
.facility-item i {
  color: #1677ff;
  margin-right: 6px;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label .facility-item) {
  border-color: #1677ff;
  background: #f0f7ff;
}

.form-actions {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 12px;
  justify-content: center;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .venue-add-container {
    padding: 10px;
  }
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .header-actions {
    margin-top: 10px;
    width: 100%;
    text-align: right;
  }
  .form-section {
    padding: 14px;
  }
  .facilities-group {
    grid-template-columns: 1fr 1fr;
  }
  .form-actions {
    flex-direction: column;
  }
  .form-actions .el-button {
    width: 100%;
  }
}
</style>